import { lazy } from 'react';

export { ACTOR_PROFILE } from './routes';

export const ActorProfileFeature = lazy(() => import('./pages/ActorProfileFeature'));
